<template>
    <div id="cancel-accept-plane-buttons" class="lb-btn-container">
        <div class="grey-outline-pill-button" v-on:click="cancel">Отменить</div>
        <div class="red-pill-button-of-hate go-next extra-left-margin" v-on:click="accept">Готово</div>
    </div>
</template>

<script>
    import {bus} from "../../../vue_bus";

    export default {
        name: "RightLowerBarScaleConfirmation",
        props: {
            version: {
                type: String
            }
        },
        computed: {
            activeStep() {
                return this.$store.state.route.name
            },
            idActivePhoto(){
                return this.$store.state.route.params.photoID;
            },
            adjacentSteps() {
                let stepsOrder = this.$store.state.UI.stepsChain[this.version].stepsOrder
                return stepsOrder[this.activeStep]
            }
        },
        methods: {
            accept () {
                // this.$router.push({name: this.adjacentSteps.prevStep})
                bus.$emit("AcceptScale", ()=>{this.$router.push({name: "planeCategoriesForPerspective"}).catch(() => {})})
            },
            cancel() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style scoped>

</style>
